let hydrationObserver = null;

export default function() {
    if (hydrationObserver) {
        return hydrationObserver;
    }

    if (typeof IntersectionObserver === 'undefined') {
        return null;
    }

    hydrationObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
            // Use `intersectionRatio` because of Edge 15's
            // lack of support for `isIntersecting`.
            // See: https://github.com/w3c/IntersectionObserver/issues/211
            const isIntersecting = entry.isIntersecting || entry.intersectionRatio > 0;
            if (!isIntersecting) {
                return;
            }

            const $target = entry.target;

            for (const hydrationWrapperFn of $target.hydrationState.hydrationQueue) {
                hydrationWrapperFn();
            }
            $target.hydrationState.hydrationQueue = [];

            observer.unobserve($target);
        });
    });

    return hydrationObserver;
}